import React, { FC, ReactNode } from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context";
import { Subscription, ROUTES } from "./common";

interface Props {
  children: ReactNode;
}

const TalentPoolGate: FC<Props> = ({ children }) => {
  const { user } = useUser();
  const navigate = useNavigate();

  const isTalentPool = user?.subscription?.name === Subscription.TALENT_POOL;

  if (isTalentPool) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh" }}>
        <Result
          status="403"
          title="Feature Not Available"
          subTitle="This feature is not included in your Talent Pool plan. Upgrade to Premium to access jobs, calendar, reports, and full candidate management."
          extra={
            <Button
              type="primary"
              size="large"
              onClick={() => navigate(ROUTES.SUBSCRIBE)}
              style={{ background: "#d1bd21", borderColor: "#d1bd21", color: "#000", fontWeight: 600 }}
            >
              Upgrade to Premium
            </Button>
          }
        />
      </div>
    );
  }

  return <>{children}</>;
};

export default TalentPoolGate;
